import React from "react";
import {Mail, PhoneCall, Clock3, MapPin} from "lucide-react";

export const Contact = () => {
    return (
        <section className='contact-section' id='contact'>

            <div className='section-content'>
                <div className='contact-panel'>
                    <h2 className='section-title'>Let's Begin Your Wellness Journey</h2>
                    <p className='contact-intro'>
                    Whether you have questions, would like to schedule a session, or simply want to learn more about my services, I'd love to hear from you. Reach out today and let's create a personalized wellness experience just for you.
                    </p>

                    <div className='contact-list'>
                        <a href='tel:+16232959893' className='contact-row contact-call-button'>
                            <span className='contact-icon'><PhoneCall/></span>
                            <span className='contact-text'>Call Now (623) 295-9893</span>
                        </a>

                        <a href='mailto:saishaspiritualtouch@gmail.com' className='contact-row'>
                            <span className='contact-icon'><Mail/></span>
                            <span className='contact-text'>saishaspiritualtouch@gmail.com</span>
                        </a>

                        <div className='contact-row'>
                            <span className='contact-icon'><Clock3/></span>
                            <span className='contact-text'>Monday through Sunday </span>
                        </div>

                        <div className='contact-row'>
                            <span className='contact-icon'><MapPin/></span>
                            <span className='contact-text'>Phoenix, Arizona</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
